import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { BuyersGroup, BuyersGroupApiService } from '../buyers-groups-item/buyers-groups.service'

@Component({
  selector: 'tc-create-from-shared-group',
  templateUrl: './create-from-shared-group.component.html',
  styleUrls: ['./create-from-shared-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateFromSharedGroupComponent {
  private formBuilder = inject(FormBuilder)
  private dialogRef = inject<MatDialogRef<CreateFromSharedGroupComponent>>(MatDialogRef)
  private buyersGroupService = inject(BuyersGroupApiService)
  private toaster = inject(ToasterService)
  private dialogData = inject<{
    buyers: string[];
}>(MAT_DIALOG_DATA)

  formGroup: FormGroup
  saving = false

  constructor() {
    this.formGroup = this.formBuilder.group({
      name: [null, Validators.required],
    })
  }

  cancel() {
    this.dialogRef.close()
  }

  async create() {
    if (!this.formGroup.valid) return
    const name = (this.formGroup.value.name as string)?.trim()
    if (!name) return

    this.saving = true
    try {
      const { data } = await this.buyersGroupService.create({ name, buyers: this.dialogData.buyers })
      this.toaster.success(`Buyer Group "${name}" was created successfully.`)
      this.dialogRef.close(data as BuyersGroup)
    } catch {
      this.toaster.error(`Unable to create Buyer Group "${name}".`)
    } finally {
      this.saving = false
    }
  }
}